import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const getTrackerReference = createAsyncThunk(
    "getTrackerReference",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/trackref/track-ref-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );

            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const TrackerReferenceSlice = createSlice({
    name: "TrackerReferenceSlice",
    initialState,

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getTrackerReference.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getTrackerReference.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(getTrackerReference.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default TrackerReferenceSlice.reducer;
